import $ from 'jquery'

export const init = async function () {
  $('#js-press-down-btn').on('click',function(){
    $('#js-press-download').removeClass('hide');
    $(this).fadeOut();
  });
}